import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

class OrderInvoiceSection extends Component {
  state = {
    pdfUrl: null,
    pdfRequested: false,
  };

  componentDidUpdate(prevProps) {
    var prevPdf = prevProps.order ? prevProps.order.invoicePdf : null;
    var currentPdf = this.props.order ? this.props.order.invoicePdf : null;

    if (currentPdf && currentPdf !== prevPdf) {
      this.updatePreviewUrl(currentPdf);
    }
  }

  componentWillUnmount() {
    this.cleanupPdfUrl();
  }

  base64ToBlob = function (base64) {
    var byteCharacters = atob(base64);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([new Uint8Array(byteNumbers)], {
      type: "application/pdf",
    });
  };

  cleanupPdfUrl = function () {
    if (this.state.pdfUrl) {
      window.URL.revokeObjectURL(this.state.pdfUrl);
    }
  }.bind(this);

  updatePreviewUrl = function (pdfBase64) {
    try {
      var blob = this.base64ToBlob(pdfBase64);
      var url = window.URL.createObjectURL(blob);
      this.cleanupPdfUrl();
      this.setState({ pdfUrl: url });
    } catch (error) {
      console.error("PDF preview error:", error);
    }
  }.bind(this);

  handleLoadPdf = function () {
    var order = this.props.order ? this.props.order.order : null;
    if (!order) return;

    // Pass invoice UUID if available for more reliable PDF retrieval
    var invoiceUuid = null;
    if (order.invoices && order.invoices.length > 0 && order.invoices[0].uuid) {
      invoiceUuid = order.invoices[0].uuid;
    }

    this.setState({ pdfRequested: true });
    this.props.getCustomerInvoicePdf(order.id, invoiceUuid);
  }.bind(this);

  handleDownloadPdf = function () {
    if (!this.state.pdfUrl) return;

    var order = this.props.order ? this.props.order.order : null;
    var invoiceNumber = "";
    if (order && order.invoices && order.invoices.length > 0) {
      invoiceNumber = order.invoices[0].invoiceNumber || "";
    }

    var link = document.createElement("a");
    link.href = this.state.pdfUrl;
    link.download = "fatura-" + (invoiceNumber || "document") + ".pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }.bind(this);

  formatInvoiceType = function (value) {
    if (!value) return "-";
    var upper = value.toString().toUpperCase();
    if (upper === "EFATURA") return "e-Fatura";
    if (upper === "EARSIV" || upper === "E-ARSIV") return "e-Arşiv";
    return value;
  };

  render() {
    var order = this.props.order ? this.props.order.order : null;
    var fetchingPdf = this.props.order
      ? this.props.order.fetchingInvoicePdf
      : false;

    if (!order) return null;

    var invoices = order.invoices || [];
    var invoice =
      invoices.length > 0 ? invoices[0] : null;
    var hasInvoice =
      invoice &&
      invoice.dpStatus &&
      (invoice.dpStatus === "SENT" ||
        invoice.dpStatus === "APPROVED" ||
        invoice.dpStatus === "QUEUED");
    var orderStatus = order.status || "";

    // Fatura yoksa bilgilendirme mesajı
    if (!hasInvoice) {
      var isDelivered =
        orderStatus === "Teslim Edildi" || orderStatus === "Tamamlandı";

      return React.createElement(
        "div",
        { className: "invoice-section" },
        React.createElement(
          "div",
          { className: "invoice-no-data" },
          React.createElement(
            "div",
            { className: "invoice-no-data-icon" },
            React.createElement(FontAwesomeIcon, { icon: "file-invoice" })
          ),
          React.createElement(
            "h4",
            { className: "invoice-no-data-title" },
            "Fatura Henüz Oluşturulmadı"
          ),
          React.createElement(
            "p",
            { className: "invoice-no-data-text" },
            isDelivered
              ? "Faturanız hazırlanmaktadır, kısa süre içinde burada görüntüleyebileceksiniz."
              : "Siparişiniz tamamlandıktan/teslim edildikten sonra 3 iş günü içerisinde faturanız otomatik olarak oluşturulacaktır."
          )
        )
      );
    }

    // Fatura varsa
    return React.createElement(
      "div",
      { className: "invoice-section" },

      // Fatura Bilgileri
      React.createElement(
        "div",
        { className: "invoice-info-card" },
        React.createElement(
          "div",
          { className: "invoice-info-grid" },
          React.createElement(
            "div",
            { className: "invoice-info-item" },
            React.createElement(
              "span",
              { className: "invoice-info-label" },
              "Fatura No"
            ),
            React.createElement(
              "span",
              { className: "invoice-info-value invoice-number" },
              invoice.invoiceNumber || "-"
            )
          ),
          React.createElement(
            "div",
            { className: "invoice-info-item" },
            React.createElement(
              "span",
              { className: "invoice-info-label" },
              "Fatura Tipi"
            ),
            React.createElement(
              "span",
              { className: "invoice-info-value" },
              React.createElement(
                "span",
                {
                  className:
                    "invoice-type-badge " +
                    (invoice.invoiceType === "EFATURA"
                      ? "badge-efatura"
                      : "badge-earsiv"),
                },
                this.formatInvoiceType(invoice.invoiceType)
              )
            )
          ),
          React.createElement(
            "div",
            { className: "invoice-info-item" },
            React.createElement(
              "span",
              { className: "invoice-info-label" },
              "Oluşturulma Tarihi"
            ),
            React.createElement(
              "span",
              { className: "invoice-info-value" },
              invoice.created_at
                ? moment(invoice.created_at).format("DD/MM/YYYY")
                : "-"
            )
          ),
          React.createElement(
            "div",
            { className: "invoice-info-item" },
            React.createElement(
              "span",
              { className: "invoice-info-label" },
              "Durum"
            ),
            React.createElement(
              "span",
              { className: "invoice-info-value" },
              React.createElement(
                "span",
                { className: "invoice-status-badge" },
                invoice.dpStatus === "SENT" || invoice.dpStatus === "APPROVED"
                  ? "Onaylandı"
                  : invoice.dpStatus === "QUEUED"
                  ? "İşleniyor"
                  : invoice.dpStatus || "-"
              )
            )
          )
        )
      ),

      // Butonlar
      React.createElement(
        "div",
        { className: "invoice-actions" },
        !this.state.pdfRequested
          ? React.createElement(
              "button",
              {
                className: "invoice-btn invoice-btn-primary",
                onClick: this.handleLoadPdf,
                disabled: fetchingPdf,
              },
              React.createElement(FontAwesomeIcon, {
                icon: fetchingPdf ? "spinner" : "file-pdf",
                spin: fetchingPdf,
                style: { marginRight: "8px" },
              }),
              fetchingPdf ? "PDF Yükleniyor..." : "Faturayı Görüntüle"
            )
          : null,
        this.state.pdfUrl
          ? React.createElement(
              React.Fragment,
              null,
              React.createElement(
                "button",
                {
                  className: "invoice-btn invoice-btn-success",
                  onClick: this.handleDownloadPdf,
                },
                React.createElement(FontAwesomeIcon, {
                  icon: "download",
                  style: { marginRight: "8px" },
                }),
                "PDF İndir"
              ),
              React.createElement(
                "a",
                {
                  href: this.state.pdfUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: "invoice-btn invoice-btn-outline",
                },
                React.createElement(FontAwesomeIcon, {
                  icon: "external-link-alt",
                  style: { marginRight: "8px" },
                }),
                "Yeni Sekmede Aç"
              )
            )
          : null
      ),

      // PDF Önizleme
      this.state.pdfRequested
        ? React.createElement(
            "div",
            { className: "invoice-pdf-preview" },
            React.createElement(
              "div",
              { className: "invoice-pdf-header" },
              React.createElement(FontAwesomeIcon, {
                icon: "file-pdf",
                style: { marginRight: "8px", color: "#e74c3c" },
              }),
              "PDF Önizleme"
            ),
            fetchingPdf && !this.state.pdfUrl
              ? React.createElement(
                  "div",
                  { className: "invoice-pdf-loading" },
                  React.createElement(
                    "div",
                    { className: "loading-spinner" },
                    null
                  ),
                  React.createElement(
                    "p",
                    { className: "invoice-pdf-loading-text" },
                    "Fatura PDF yükleniyor..."
                  )
                )
              : null,
            this.state.pdfUrl
              ? React.createElement(
                  "div",
                  { className: "invoice-pdf-container" },
                  React.createElement("object", {
                    data: this.state.pdfUrl,
                    type: "application/pdf",
                    width: "100%",
                    height: "600px",
                    style: { border: "none" },
                  })
                )
              : null,
            !fetchingPdf && !this.state.pdfUrl && this.state.pdfRequested
              ? React.createElement(
                  "div",
                  { className: "invoice-pdf-error" },
                  React.createElement(FontAwesomeIcon, {
                    icon: "exclamation-triangle",
                    style: {
                      marginRight: "8px",
                      color: "#f39c12",
                      fontSize: "24px",
                    },
                  }),
                  React.createElement(
                    "p",
                    null,
                    "PDF yüklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin."
                  )
                )
              : null
          )
        : null
    );
  }
}

export default OrderInvoiceSection;



// WEBPACK FOOTER //
// ./src/components/OrderInvoiceSection.js